module.exports = __webpack_public_path__ + "static/media/po-reman-2-1.3bda8cf5.png";